import { Head, Link } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';
import TrashedMessage from '@/Shared/TrashedMessage';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Link: Link,
    LoadingButton: LoadingButton,
    SelectInput: SelectInput,
    TextInput: TextInput,
    TrashedMessage: TrashedMessage
  },
  layout: Layout,
  props: {
    organization: Object
  },
  remember: 'form',
  data: function data() {
    return {
      form: this.$inertia.form({
        name: this.organization.name,
        email: this.organization.email,
        phone: this.organization.phone,
        address: this.organization.address,
        city: this.organization.city,
        region: this.organization.region,
        country: this.organization.country,
        postal_code: this.organization.postal_code
      })
    };
  },
  methods: {
    update: function update() {
      this.form.put("/organizations/".concat(this.organization.id));
    },
    destroy: function destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia["delete"]("/organizations/".concat(this.organization.id));
      }
    },
    restore: function restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put("/organizations/".concat(this.organization.id, "/restore"));
      }
    }
  }
};